module.exports = __webpack_public_path__ + "static/GDPR-e81c2120942329b74df03d9e733aa887.jpg";